import { render, staticRenderFns } from "./settlemen.vue?vue&type=template&id=5c23e315&scoped=true"
import script from "./settlemen.vue?vue&type=script&lang=js"
export * from "./settlemen.vue?vue&type=script&lang=js"
import style0 from "./settlemen.vue?vue&type=style&index=0&id=5c23e315&prod&lang=scss&scoped=true"
import style1 from "./settlemen.vue?vue&type=style&index=1&id=5c23e315&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23e315",
  null
  
)

export default component.exports